document.addEventListener("DOMContentLoaded", function(){

    var chatButton = document.getElementsByClassName('live-chat-launch');
    
    

    for (var i = 0; i < chatButton.length; i++) {
        chatButton[i].addEventListener('click', function(event) {
            event.preventDefault();
          LiveChatWidget.call('maximize');
        })
     }

});